var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._b({},'div',_vm.$attrs,false),[_c('span',{class:_vm.textClass},[_vm._v(_vm._s(_vm.starNumber)+"つ星ホテル")]),_vm._l((_vm.starUrls),function(starUrl,index){return _c('img',{key:index,attrs:{"src":starUrl}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }